<template>
	<journey-wrapper save>
		<stock-summary v-if="store.journey" :journey="store.journey" />

		<app-alert v-if="store.journey?.type == 'DEL'" spacing="my-4">
			CUSTOMER SIGNATURE IS TO ACCEPT QUANTITY OF GOODS, MINIMUM HIRE PERIOD PER ITEM, THE
			CONDITION OF THE GOODS ARE FIT FOR PURPOSE, RECEIPT OF USER GUIDES (AS INDICATED ABOVE)
			& RECEIPT OF LIFTING EQUIPMENT TEST CERTIFICATES, AS APPLICABLE
		</app-alert>

		<app-alert v-if="store.journey?.type == 'COL'" spacing="my-4">
			CUSTOMER SIGNATURE IS TO CONFIRM COLLECTION OF GOODS, A FINAL COUNT & ASSESSMENT OF
			CONDITION WILL BE MADE AT OUR DEPOT. A GOODS INWARDS NOTE, DETAILING THE COUNT AND ANY
			COSTS INCURRED, WILL FOLLOW
		</app-alert>

		<div v-if="store.showActions">
			<app-panel title="Signature" class="mt-3">
				<app-input
					v-model="store.journey!.signature_name"
					placeholder="Print name"
					:disabled="store.signatureSaved" />
				<div class="flex justify-center my-3">
					<img
						v-if="store.signature"
						:src="store.signature"
						alt="Signature"
						class="max-w-full w-[300px]" />
				</div>

				<app-signature
					v-if="!store.signatureSaved"
					@stop-drawing="(base64) => (store.journey!.signature = base64)"
					@clear="store.journey!.signature = undefined" />
			</app-panel>
		</div>

		<app-alert v-if="store.journey?.type != 'DOF'" theme="warning" spacing="my-4">
			Any quoted carriage charge allows for 30 MINUTES load/unloading time on site. Should our
			vehicle be held up on site any longer than this, we reserve the right to charge for
			waiting time. It is your responsibility to unload/re-load the equipment from/onto our
			vehicle. This includes arranging for suitable lifting appliances to be available when
			our vehicle arrives.
		</app-alert>

		<journey-nav
			:current="3"
			prev="photo"
			next="survey"
			:disabled="!store.step3Complete"
			:method="!store.signatureSaved ? store.saveSignature : undefined" />
	</journey-wrapper>
</template>

<script lang="ts" setup>
	import StockSummary from '@/components/partials/driver-app/StockSummary.vue'
	import AppSignature from '@/components/base/forms/AppSignature.vue'
	import JourneyWrapper from '@/components/layout/driver-app/JourneyWrapper.vue'
	import JourneyNav from '@/components/partials/driver-app/JourneyNav.vue'
	import useDriverApp from '@/stores/driver-app'

	// Resources
	const store = useDriverApp()
</script>
